import { TooltipTrigger } from "shared/components/Tooltip";
import { TooltipContent } from "shared/components/Tooltip";
import { Tooltip } from "shared/components/Tooltip";
import { PropertyGroupSplitBy } from "../../../types";
import { Dispatch, FC, SetStateAction, useCallback } from "react";
import { formatTitle } from "utils/formatTitle";
import { Show } from "shared/components/helpers/Show";
import { Card } from "shared/components/Card";
import { Checkbox } from "shared/components/forms/Checkbox";
import { cx } from "utils/classnames";
import { propertyGroupTitleMap } from "views/property-groups-configuration/constants";

interface PropertyGroupSelectorProps {
  selectedSplitOptions: PropertyGroupSplitBy[];
  setSelectedSplitOptions: Dispatch<SetStateAction<PropertyGroupSplitBy[]>>;
  supportedSplitByOptions: PropertyGroupSplitBy[];
}

export const PropertyGroupSelector: FC<PropertyGroupSelectorProps> = ({
  selectedSplitOptions,
  setSelectedSplitOptions,
  supportedSplitByOptions
}) => {
  const getDisabledMessage = useCallback(
    (group: PropertyGroupSplitBy) => {
      return selectedSplitOptions.length >= 3 &&
        !selectedSplitOptions.includes(group)
        ? "You can select up to 3 variables"
        : undefined;
    },
    [selectedSplitOptions]
  );

  const handleSelectGroup = useCallback(
    (group: PropertyGroupSplitBy) => {
      setSelectedSplitOptions((prev) => {
        const isSelected = prev.includes(group);

        const updatedSelection = isSelected
          ? prev.filter((g) => g !== group)
          : [...prev, group];

        const enumOrder = Object.values(PropertyGroupSplitBy);

        return updatedSelection.sort(
          (a, b) => enumOrder.indexOf(a) - enumOrder.indexOf(b)
        );
      });
    },
    [setSelectedSplitOptions]
  );

  return (
    <div
      className={cx(
        "grid grid-cols-1 gap-4 max-w-[780px]",
        supportedSplitByOptions.length === 4
          ? "md:grid-cols-4"
          : "md:grid-cols-3"
      )}
    >
      {supportedSplitByOptions.map((group) => {
        return (
          <Tooltip key={group}>
            <TooltipTrigger>
              <Card
                onClick={() => handleSelectGroup(group)}
                className={cx(
                  "p-6 border",
                  getDisabledMessage(group) && "pointer-events-none hover:none"
                )}
              >
                <div className="pointer-events-none">
                  <Checkbox
                    checked={selectedSplitOptions.includes(group)}
                    label={formatTitle(propertyGroupTitleMap[group])}
                    onChange={() => {
                      //don't use it
                    }}
                    disabled={Boolean(getDisabledMessage(group))}
                  />
                </div>
              </Card>
            </TooltipTrigger>
            <Show if={getDisabledMessage(group)}>
              <TooltipContent className="max-w-[300px] rounded-lg border bg-alpha-800 p-4 text-sm text-white z-[13]">
                {getDisabledMessage(group)}
              </TooltipContent>
            </Show>
          </Tooltip>
        );
      })}
    </div>
  );
};
